<div class="overskrift">{{ 'Cellerammer'|translate }}</div>

<div class="rammer">
  @if (skjema().controls.rammer!.controls.alle.enabled) {
    <div (click)="toggleRammevalgSettAlleAndreFalse('alle')" [class.valgt]="skjema().value.rammer!.alle" class="ramme" data-testid="rammer-alle">
      <mat-icon>border_all</mat-icon>
    </div>
  }
  @if (skjema().controls.rammer!.controls.mellom.enabled) {
    <div (click)="toggleRammevalgSettAlleAndreFalse('mellom')" [class.valgt]="skjema().value.rammer!.mellom" class="ramme" data-testid="rammer-mellom">
      <mat-icon>border_inner</mat-icon>
    </div>
  }
  @if (skjema().controls.rammer!.controls.omkring.enabled) {
    <div (click)="toggleRammevalgSettAlleAndreFalse('omkring')" [class.valgt]="skjema().value.rammer!.omkring" class="ramme" data-testid="rammer-omkring">
      <mat-icon>border_outer</mat-icon>
    </div>
  }

  @if (skjema().controls.rammer!.controls.topp.enabled) {
    <div (click)="toggleRammevalgSettGrupperteFalse('topp')" [class.valgt]="skjema().value.rammer!.topp" class="ramme">
      <mat-icon>border_top</mat-icon>
    </div>
  }
  @if (skjema().controls.rammer!.controls.horisontalMellom.enabled) {
    <div (click)="toggleRammevalgSettGrupperteFalse('horisontalMellom')" [class.valgt]="skjema().value.rammer!.horisontalMellom" class="ramme">
      <mat-icon>border_horizontal</mat-icon>
    </div>
  }
  @if (skjema().controls.rammer!.controls.bunn.enabled) {
    <div (click)="toggleRammevalgSettGrupperteFalse('bunn')" [class.valgt]="skjema().value.rammer!.bunn" class="ramme">
      <mat-icon>border_bottom</mat-icon>
    </div>
  }

  @if (skjema().controls.rammer!.controls.venstre.enabled) {
    <div (click)="toggleRammevalgSettGrupperteFalse('venstre')" [class.valgt]="skjema().value.rammer!.venstre" class="ramme">
      <mat-icon>border_left</mat-icon>
    </div>
  }
  @if (skjema().controls.rammer!.controls.vertikalMellom.enabled) {
    <div (click)="toggleRammevalgSettGrupperteFalse('vertikalMellom')" [class.valgt]="skjema().value.rammer!.vertikalMellom" class="ramme">
      <mat-icon>border_vertical</mat-icon>
    </div>
  }
  @if (skjema().controls.rammer!.controls.hoeyre.enabled) {
    <div (click)="toggleRammevalgSettGrupperteFalse('hoeyre')" [class.valgt]="skjema().value.rammer!.hoeyre" class="ramme">
      <mat-icon>border_right</mat-icon>
    </div>
  }

  <div (click)="fjernRammer()" class="ramme" matTooltip="{{'Fjern alle rammer'|translate}}">
    <mat-icon>border_clear</mat-icon>
  </div>
  <!--
  <button mat-stroked-button type="button" (click)="fjernRammer()" class="fjern-rammer" matTooltip="{{'Fjern alle rammer'|translate}}">
    <mat-icon>ink_eraser</mat-icon>
  </button>-->

</div>

<div class="valg">
  <button mat-stroked-button
          type="button"
          class="fargevelger"
          ngx-colors-trigger
          [formControl]="skjema().controls.farge"
          format="hex"
          colorPickerControls="no-alpha"
          acceptLabel="{{'Velg' | translate}}"
          cancelLabel="{{'Avbryt' | translate}}"
          matTooltip="{{'Endre ramme-farge'|translate}}">
    <span class="farge" [style.background]="skjema().controls.farge.value"></span>
  </button>

  <button mat-stroked-button type="button" matTooltip="{{'Endre ramme-tykkelse'|translate}}">
    <mat-select [formControl]="skjema().controls.tykkelse" panelClass="velg-strektykkelse--alternativer" panelWidth="null">
      <mat-select-trigger>
        <div class="tykkelse-valg">
          <span [style.border-width]="skjema().controls.tykkelse.value+'px'" class="tykkelse-illustrasjon"></span>
        </div>
      </mat-select-trigger>
      @for (tykkelse of tilgjengeligeTykkelse; track tykkelse) {
        <mat-option [value]="tykkelse">
          <div class="tykkelse-valg">
            <span [style.border-width]="tykkelse+'px'" class="tykkelse-illustrasjon"></span>
            {{ tykkelse }}px
          </div>
        </mat-option>
      }
    </mat-select>
  </button>
</div>
